<!-- Toolbar -->
<data-table-toolbar
	[actionset]="actionset ?? null"
	[disabledActions]="disabledActions"
	[length]="tableController.numElementsSize"
	[numElementsLoaded]="tableController.numElementsLoaded"
	[pageEvent]="pageEvent"
	[showColumnSettings]="showColumnSettings"
	[showMultiselectDropdown]="showMultiselectDropdown"
	[showMultiselectDropdownMenu]="showMultiselectDropdownMenu"
	(actionEmit)="handleToolbarAction($event)"
	(addClick)="onAddClick()"
	(clearSort)="onClearSortClick()"
	(resetSort)="onResetSortClick()"
	(pageChange)="onPageChange($event)"
	(openSettings)="openColumnSettingsDialog($event)"
	[manualOption]="manualOption"
	[notificationOption]="notificationOption"
	[tableController]="tableController"]
	[detailId]="detailId"
>
</data-table-toolbar>

<!-- Table Container -->
<div [class]="isDetail ? '' : 'table-responsive flex-grow-1 d-flex'">
	<div [class]="isDetail ? '' : 'table-container'">
		<div [class]="'position-relative w-100' + (isDetail ? '' : ' overflow-auto flex-grow-1')">
			<div [class]="'w-100' + (isDetail ? '' : ' position-absolute top-0 start-0') + (this.tableContainerClass? ' ' + this.tableContainerClass : '')">

				<table class="table table-striped" [class.dt-main]="!isDetail">
					<!-- Header -->
					<thead #tableTr
						   [style.top]="inverseOfTranslation"
						   [ngStyle]="{'z-index': isDetail ? 3 : 4}"
						   style="position: sticky">
					<tr>
						<!-- Multiselect checkbox header -->
						<th *ngIf="datasets?.multiselect" #selectTh class="select-col">
							<mat-checkbox
								(change)="$event ? tableController.toggleAllRows() : null"
								[aria-label]="tableController.checkboxLabel()"
								[checked]="tableController.selection.hasValue() && tableController.isAllSelected()"
								[indeterminate]="tableController.selection.hasValue() && !tableController.isAllSelected()">
							</mat-checkbox>
						</th>
						<!-- Actions header (left position for delivery planning pages) -->
						<th #actionsTh *ngIf="showActionsColumn && shouldShowActionsOnLeft()" class="actions">
							<span>
								<button *ngIf="isInEditOrInsertMode && hasAction('ACT_SAVE_ALL')"
										(click)="handleToolbarAction('ACT_SAVE_ALL')"
										class="table-button" color="primary" mat-icon-button
										matTooltip="{{ 'LABEL_SAVE' | translate }}">
									<mat-icon>save</mat-icon>
								</button>
								<button *ngIf="!isInEditOrInsertMode && hasAction('ACT_EDIT_ALL')"
										(click)="editAll()"
										class="table-button" color="primary" mat-icon-button
										matTooltip="{{ 'LABEL_EDIT' | translate }}">
									<mat-icon>edit</mat-icon>
								</button>
								<button *ngIf="isInEditOrInsertMode && (hasAction('ACT_EDIT_ALL') || hasAction('ACT_SAVE_ALL'))"
										(click)="exitAllRow()"
										class="table-button" color="primary" mat-icon-button
										matTooltip="{{ 'LABEL_CANCEL' | translate }}">
									<mat-icon>cancel</mat-icon>
								</button>
							</span>
						</th>
						<!-- Column headers -->
						<th *ngFor="let column of visibleColumns; trackBy: trackByColumnName"
							(click)="sortColumn(column.columnName)"
							[style.max-width.px]="((tableController.columnSize[column.columnName] || MIN_COL_WIDTH) + (isSortable && getSortedColumnInfo(column.columnName)? 35: 16))"
							[style.min-width.px]="(isInEditOrInsertMode && (column.type === 'DTY_DATE' || column.type === 'DTY_TIME')) ? 170 : ((tableController.columnSize[column.columnName] || MIN_COL_WIDTH) + (isSortable && getSortedColumnInfo(column.columnName)? 35: 16))"
							[style.width.px]="((tableController.columnSize[column.columnName] || MIN_COL_WIDTH) + (isSortable && getSortedColumnInfo(column.columnName)? 35: 16))"
							class="pointer">
								<span class="table-button-container">
									<span class="table-header-label">{{ column.columnLabel | translate }}</span>
									<ng-container *ngIf="isSortable && getSortedColumnInfo(column.columnName) as sortInfo">
										<mat-icon *ngIf="sortInfo.type === 'asc'">arrow_upward</mat-icon>
										<mat-icon *ngIf="sortInfo.type === 'desc'" class="sorter-icon">arrow_downward</mat-icon>
										<label class="sort-order">{{ sortInfo.order }}</label>
									</ng-container>
								</span>
						</th>

						<!-- Actions header (right position for other pages) -->
						<th #actionsTh *ngIf="showActionsColumn && !shouldShowActionsOnLeft()" class="actions">
								<span>
									<button *ngIf="isInEditOrInsertMode && hasAction('ACT_SAVE_ALL')"
											(click)="handleToolbarAction('ACT_SAVE_ALL')"
											class="table-button" color="primary" mat-icon-button
											matTooltip="{{ 'LABEL_SAVE' | translate }}">
										<mat-icon>save</mat-icon>
									</button>
									<button *ngIf="!isInEditOrInsertMode && hasAction('ACT_EDIT_ALL')"
											(click)="editAll()"
											class="table-button" color="primary" mat-icon-button
											matTooltip="{{ 'LABEL_EDIT' | translate }}">
										<mat-icon>edit</mat-icon>
									</button>
									<button *ngIf="isInEditOrInsertMode && (hasAction('ACT_EDIT_ALL') || hasAction('ACT_SAVE_ALL'))"
											(click)="exitAllRow()"
											class="table-button" color="primary" mat-icon-button
											matTooltip="{{ 'LABEL_CANCEL' | translate }}">
										<mat-icon>cancel</mat-icon>
									</button>
								</span>
						</th>
					</tr>
					</thead>

					<!-- Body -->
					<tbody>
					<!-- Empty state -->
					<tr *ngIf="tableController.dataSet.length === 0">
						<td [attr.colspan]="visibleColumns.length + (showActionsColumn ? 1 : 0) + (datasets?.multiselect? 1 : 0 )" style="display: table-cell">
							<div class="not-data-found">{{ 'LABEL_NO_DATA_FOUND' | translate }}</div>
						</td>
					</tr>

					<!-- Data rows -->
					<ng-container *ngFor="let dataRow of tableController.dataSet; let i = index; trackBy: trackByIndex">
						<tr [class.changed-row]="dataRow.isChanged"
							[class.deleted-row]="dataRow.deleted"
							[class.selected-row]="tableController.rowNumber === i"
							[class.high-prio-row]="isHighPrio(dataRow)">

							<!-- Multiselect checkbox -->
							<td *ngIf="datasets?.multiselect" class="align-middle select-col">
								<mat-checkbox
									(change)="$event ? tableController.selection.toggle(dataRow) : null"
									(click)="$event.stopPropagation()"
									[checked]="tableController.selection.isSelected(dataRow)">
								</mat-checkbox>
							</td>
							<!-- Actions column (left position for delivery planning pages) -->
							<td *ngIf="showActionsColumn && shouldShowActionsOnLeft()" class="actions">
								<data-table-row-actions
									[row]="dataRow"
									[rowIndex]="i"
									[isEditing]="dataRow?.editing"
									[isCanceled]="isRowCanceled(i)"
									[isDeleted]="dataRow?.deleted"
									[isNewRow]="dataRow?.newRow"
									[availableActions]="tableController.getAvailableActionsSet()"
									[isDeleteDisabled]="isActionDisabled('ACT_DELETE')"
									[customActions]="actionset?.actions ?? null"
									(action)="handleRowAction($event)">
								</data-table-row-actions>
							</td>
							<!-- Data cells -->
							<td *ngFor="let column of visibleColumns; trackBy: trackByColumnName"
								[style.max-width.px]="((tableController.columnSize[column.columnName] || MIN_COL_WIDTH) + (isSortable && getSortedColumnInfo(column.columnName)? 35: 16))"
								[style.min-width.px]="(dataRow?.editing && (column.type === 'DTY_DATE' || column.type === 'DTY_TIME')) ? 170 : ((tableController.columnSize[column.columnName] || MIN_COL_WIDTH) + (isSortable && getSortedColumnInfo(column.columnName)? 35: 16))"
								[style.width.px]="((tableController.columnSize[column.columnName] || MIN_COL_WIDTH) + (isSortable && getSortedColumnInfo(column.columnName)? 35: 16))"
								[ngClass]="['align-middle', getMetadataErrorCss(column, dataRow)]"
								[matTooltip]="getMetadataErrorTooltip(column, dataRow) | translate"
							>

								<data-table-cell
									[column]="column"
									[row]="dataRow"
									[rowIndex]="i"
									[isEditing]="dataRow?.editing"
									[isNewRow]="dataRow?.newRow"
									[columnWidth]="tableController.columnSize[column.columnName]"
									[disabled]="(!column.editable && !dataRow?.newRow) || disabledColumns.includes(column.columnName)"
									[errors]="dataRow?.errors"
									[filterValues]="tableController._filterValues.getValue()"
									(valueChange)="onInputChange(i)"
									(cellClick)="handleCellClick($event)"
									(errorChange)="tableController.setErrors($event.error, $event.rowIndex, $event.columnName, false)"
									(radioClick)="onRadioButtonClick($event.column, $event.rowIndex)"
									[tableName]="tableController.tableName"
								>
								</data-table-cell>
							</td>

							<!-- Actions column (right position for other pages) -->
							<td *ngIf="showActionsColumn && !shouldShowActionsOnLeft()" class="actions">
								<data-table-row-actions
									[row]="dataRow"
									[rowIndex]="i"
									[isEditing]="dataRow?.editing"
									[isCanceled]="isRowCanceled(i)"
									[isDeleted]="dataRow?.deleted"
									[isNewRow]="dataRow?.newRow"
									[availableActions]="tableController.getAvailableActionsSet()"
									[isDeleteDisabled]="isActionDisabled('ACT_DELETE')"
									[customActions]="actionset?.actions ?? null"
									(action)="handleRowAction($event)">
								</data-table-row-actions>
							</td>
						</tr>

						<!-- Inner table row -->
						<tr *ngIf="dataRow.isInnerTableVisible">
							<td [attr.colspan]="visibleColumns.length + 2" style="padding: unset" class="inner">
								<detail-data-table
									class="container-section"
									[apiParent]="apiParent"
									[apiUrl]="apiUrl + '/inner'"
									[pageId]="'INNER_' + pageId"
									[id]="dataRow.ID"
									[isInner]="true"
									[mainGridReloadData]="reloadData">
								</detail-data-table>
							</td>
						</tr>
					</ng-container>
					</tbody>
				</table>

			</div>
		</div>
	</div>
</div>
<br>
